export default {
  "pl": {
    "decision": {
      "actions": {
        "add": "Dodaj",
        "addUnits": "Dodaj jednostki",
        "approve": "Zatwierdź",
        "cancel": "Cofnij",
        "changeResponsible": "Zmień osobę odpowiedzialną",
        "clickToSetDeadline": "Kliknij, aby wybrać termin",
        "confirmChoices": "Zatwierdź wybory",
        "create_decisions": "Utwórz decyzję | Utwórz decyzje",
        "delete": "Usuń",
        "deleteCount": "Zamierzasz usunąć {count} decyzję. Czy na pewno chcesz to zrobić? | Zamierzasz usunąć następującą liczbę decyzji: {count}. Na pewno chcesz to zrobić?",
        "deleteMultipleDecisions": "Usuń…",
        "delete_cancel": "Anuluj",
        "delete_decisions": "Usuń decyzję | Usuń decyzje",
        "edit": "Edytuj",
        "editBudget": "Edytuj budżet",
        "editDeadline": "Zmień termin",
        "editDecision": "Edytuj decyzję",
        "editReminders": "Edytuj przypomnienia",
        "goToProposal": "Przejdź do propozycji",
        "goToSummary": "Przejdź do podsumowania",
        "hide": "Cofnij publikację",
        "hideInfo": "Ukryj informacje",
        "noDescription": "Kliknij, aby dodać opis",
        "publish": "Opublikuj",
        "publishAll": "Dla wszystkich",
        "publishCustomer": "Opublikuj dla klienta",
        "publishPartners": "Opublikuj dla partnera(-ów) decyzyjni",
        "reject": "Odrzucić",
        "reset": "Zresetuj",
        "save": "Zapisz",
        "selectAll": "Wybierz wszystkie jednostki ({total})",
        "selectAndApprove": "Wybierz i zatwierdź",
        "share_proposals": "Podziel się propozycjami",
        "showMoreInfo": "Pokaż więcej informacji",
        "stopApproving": "Przerwij zatwierdzanie",
        "submit": "Prześlij",
        "tickBoxesDeletion": "Zaznacz pola wyboru przy plikach, które chcesz usunąć.",
        "unSelectAll": "Wyczyść wybór.",
        "unpublishForCustomer": "Cofnij publikację dla klienta",
        "unpublishForPartners": "Cofnij publikację dla partnera decyzyjni",
        "update": "Zaktualizuj",
        "upload": "Prześlij",
        "upload_documents": "Prześlij dokumenty",
        "upload_proposals": "Prześlij propozycje"
      },
      "attributes": {
        "approved_at": "Data zatwierdzenia wniosku",
        "approved_proposal_name": "Nazwa zatwierdzonej propozycji",
        "bathrooms": "Ilość łazienek",
        "bedrooms": "Liczba sypialni",
        "customer_group_name": "Klient",
        "decisions_count": "{count} decyzja | Liczba decyzji: {count}",
        "due_date": "Termin",
        "floor": "Kondygnacja",
        "negative_surcharges_allowed": "Zezwól na niedoładowanie",
        "note_employee": "Notatka",
        "price_budget": "Budżet",
        "price_surcharge": "Opłata dodatkowa",
        "published": "Opublikowano",
        "responsible": "Osoba odpowiedzialna",
        "status": "Status",
        "unit": "Jednostka",
        "verification_type": "Decyzja zatwierdzona przez:",
        "visibility": "Widoczność"
      },
      "edit_actions": {
        "edit_close_decision": "Zamknij/otwórz decyzję",
        "edit_deadline": "Termin",
        "edit_negative_surcharges_allowed": "Zezwól na niedoładowanie",
        "edit_note_employee": "Notatka",
        "edit_price_budget": "Budżet",
        "edit_reminders": "Przypomnienia",
        "edit_responsible": "Osoba odpowiedzialna"
      },
      "labels": {
        "accessRights": "Uprawnienia dostępu",
        "activity": "Aktywność",
        "addDecisionNote": "Dodaj notatkę",
        "addReminders": "Dodaj przypomnienia",
        "allUnits": "Wszystkie jednostki",
        "allUnitsAssigned": "Wszystkie przypisane jednostki",
        "approved": "Zatwierdzono",
        "approvedAt": "Zatwierdzono dnia {approved_at}",
        "approvedProposal": "Oferta zatwierdzona",
        "askQuestion": "Tu możesz zadać pytania dotyczące decyzji: {decision}",
        "assignCustomerToUnit": "Przypisz klienta",
        "budgetSubtitle": "Podaj tutaj budżet, jeśli ma zastosowanie do wszystkich wybranych jednostek, lub dodaj budżet później",
        "budgetTitle": "Określanie budżetu",
        "checkbox": "Pole wyboru",
        "clickHereToChange": "Kliknij tutaj, jeśli chcesz wprowadzić zmiany.",
        "close": "Zamknąć",
        "closed": "Decyzja jest zamknięta dla tej jednostki. Klient nie będzie już mógł zatwierdzić propozycji.",
        "closed_tag": "Decyzja zamknięta",
        "countDocuments": "Brak dokumentów | 1 dokument | Liczba dokumentów: {count}",
        "countEdit": "Zmień decyzję dla {count} jednostki | Zmień decyzję dla następującej liczby jednostek: {count}",
        "countUpload": "Prześlij dokument(y) dla tej jednostki | Prześlij dokumenty dla następującej liczby jednostek: {count}",
        "created_on": "Data utworzenia decyzji: {date}",
        "custom_columns_title": "Możesz dodać do 10 kolumn",
        "customer": "Klient",
        "customer_status": "Status klienta",
        "decided": "Decyzja podjęta",
        "decision": "Decyzji",
        "decisionBreadcrumb": "Decyzja: {decision_type}",
        "decisionNotPublishedYetFor": "Decyzja nie została jeszcze opublikowana dla:",
        "decisionNoteExplainer": "Ta notatka będzie widoczna wyłącznie dla członków twojego zespołu i dla partnerów, którzy mają uprawnienia do wyświetlenia tej decyzji",
        "decisionType": "Temat decyzji",
        "decisionUnit": "Decyzja dla jednostki: {unit}",
        "decisions": "Decyzje",
        "default": "Domyślnie",
        "deleteExplanation": "Wszystkie komunikaty, pliki, oferty i inne dane zostaną trwale usunięte z platformy. Klienci i partnerzy przypisani do tych decyzji utracą do nich wszelki dostęp.",
        "descriptionSubtitle": "Tutaj możesz dodać więcej informacji dla klientów",
        "descriptionTitle": "Dodaj opis dla klienta",
        "documentRequired": "Do zatwierdzenia jest wymagany podpisany dokument",
        "documentUnits": "Folder jednostki",
        "documents": "Dokumenty decyzyjne",
        "dueDate": "Termin: {date}",
        "due_date_subtitle": "Ustal datę, do której należy podjąć decyzję",
        "due_date_title": "Termin i przypomnienia",
        "editDecisionNote": "Edytuj notatkę",
        "false": "Nie",
        "finalSettings": "Ustawienia opcjonalne",
        "finalSettingsStep": "Ustawienia końcowe",
        "firstThingsfirst": "Najpierw trochę ogólnych informacji",
        "follow": "Śledzić",
        "following": "Następny",
        "four": "4",
        "giveNewAmount": "Podaj nową wartość",
        "hideCount": "Cofnij publikację tej decyzji dla 1 jednostki | Cofnij publikację tej decyzji dla następującej liczby jednostek: {count}",
        "hideVisibilitySettings": "Ukryj ustawienia dotyczące widoczności",
        "information": "Informacje",
        "members": "Członkowie",
        "modifyLater": "Te ustawienia możesz zmienić później",
        "name": "Nazwa",
        "newDocument": "Nowy(-e) dokument(y)",
        "next": "Dalej",
        "no": "Nie",
        "noApprovedProposalYet": "Nikt jeszcze nie zaakceptował żadnej oferty",
        "noBudget": "Nie określono budżetu",
        "noCustomer": "Brak klientów",
        "noCustomerAssigned": "Nie przypisano jeszcze żadnego klienta do jednostki",
        "noDeadline": "Brak terminu",
        "noDecisionDueDate": "Wybierz termin",
        "noDecisionStartDate": "Nie ustawiono daty rozpoczęcia",
        "noDecisionsMade": "Nie podjęto jeszcze żadnych decyzji",
        "noDecisionsToMake": "Nie ma żadnych decyzji do podjęcia.",
        "noDecisionsYet": "Brak decyzji",
        "noDocumentsShared": "Brak udostępnionych dokumentów",
        "noDueDate": "Zanim przejdziesz do ustawień dotyczących przypomnień, wyznacz termin",
        "noDueDateSet": "Nie wyznaczono terminu",
        "noMessages": "Poniżej wpisz treść pierwszej wiadomości dotyczącej decyzji: {decision}",
        "noUnitDocuments": "Do folderu jednostki nie dodano jeszcze żadnych dokumentów",
        "noUnitsClick": "Brak jednostek – kliknij tutaj, aby dodać",
        "notDecided": "Nie podjęto jeszcze decyzji",
        "notDecidedYet": "Klient nie podjął jeszcze decyzji.",
        "notFollowing": "Nie śledzić",
        "notPossibleToWriteMessageDeactivatedUnit": "Ta decyzja jest związana z dezaktywowaną jednostką. Napisanie nowej wiadomości nie jest już możliwe.",
        "notPublished": "Nie opublikowano",
        "notShared": "Nie udostępniono",
        "one": "1",
        "open": "Otwarte",
        "open_close_unit": "decyzja dla 1 jednostki | decyzja dla {unit_count} jednostek",
        "or": "lub",
        "participants": "Uczestnicy",
        "partners": "Partnerzy decyzyjni",
        "pendingDecisions": "1 decyzja do podjęcia | Liczba decyzji do podjęcia: {count}",
        "priceBudget": "Budżet: {price_budget}",
        "proposals": "Oferty | 1 Oferta | {count} Oferty",
        "publish?": "Zapisać i opublikować?",
        "publishNow?": "Opublikować teraz?",
        "publishTopOfPage": "Tę decyzję możesz opublikować u góry strony",
        "publishedCount": "Opublikuj tę decyzję dla 1 jednostki | Opublikuj tę decyzję dla następującej liczby jednostek: {count}",
        "publishedCustomer": "Opublikowano dla klienta",
        "publishedCustomerPartners": "Opublikowano dla klienta i partnerów decyzyjni",
        "publishedNone": "Nie opublikowano",
        "publishedPartners": "Opublikowano dla partnerów decyzyjni",
        "publishedSince": "Opublikowana od: {date}",
        "published_info": "Pokazuje, czy wszystkie jednostki zostały opublikowane dla klienta i/lub partnerów decyzyjni",
        "reminders": "Przypomnienia",
        "remindersCount": "1 przypomnienie | Liczba przypomnień: {count}",
        "requiresDocumentVerification": "Do zatwierdzenia jest wymagany podpisany dokument",
        "requiresNoDocumentVerification": "Do zatwierdzenia nie jest wymagany podpisany dokument",
        "returnToTickets": "Wróć",
        "rights": {
          "access_full": "Pełny dostęp",
          "access_none": "Ograniczony dostęp",
          "access_semi": "Podstawowy dostęp",
          "customer_show": "Informacje o kliencie są widoczne.",
          "default": "Partnerzy decyzji mogą wysyłać wiadomości, przesyłać dokumenty i tworzyć oferty dla klienta <b>{client_name}</b> w dowolnym czasie. Mają także dostęp do planów w folderze z dokumentami jednostki. Poniżej możesz zmienić ich uprawnienia dotyczące komunikacji z twoimi klientami.",
          "document_customer": "Mogą bezpośrednio udostępniać swoje dokumenty klientowi.",
          "message_customer": "Mogą wysyłać wiadomości do klienta.",
          "proposal_customer": "Mogą bezpośrednio udostępniać swoje oferty klientowi."
        },
        "save?": "Zapisać?",
        "saveExplainer": "Czy chcesz, żeby twoi klienci zobaczyli tę decyzję? Możesz też ją zapisać i opublikować później.",
        "select": "Wybierz",
        "selectOneUnit": "Wybierz przynajmniej 1 jednostkę",
        "selectUnits": "Wybierz jednostki",
        "selected": "Wybrano {selected} jednostkę. | Wybrano następującą liczbę jednostek: {selected}.",
        "sharedWith": "Udostępniono:",
        "showDecisionsFor": "Pokaż decyzje dla:",
        "signOnline": "Wpisz nazwę klienta, aby potwierdzić (domyślnie)",
        "signUploadDocument": "Prześlij podpisany dokument",
        "signedDocument": "Prześlij podpisany dokument",
        "status": "Status",
        "statusExplained": "Co oznacza każdy ze statusów decyzji?",
        "step2Subtitle": "Wybierz swój projekt, aby uwzględnić wszystkie jednostki naraz.",
        "step2Title": "Które jednostki mają podjąć decyzję?",
        "step2TitleWithDecisionName": "Które jednostki mają podjąć decyzję dotyczącą: {decision_name}?",
        "subject": "Temat",
        "summary": "Podsumowanie",
        "three": "3",
        "tickets": "Rozmowy decyzyjne",
        "toBeDecided": "Do podjęcia",
        "totalSelected": "Wybrano wszystkie jednostki ({total}).",
        "true": "Tak",
        "two": "2",
        "type": "Rodzaj",
        "unitDecisionsWillBeShownHere": "W tym miejscu będą widoczne decyzje jednostek",
        "unitNotActivated": "Tylko dla jednostek aktywowanych",
        "unitSelected": "Brak jednostek | 1 jednostka | Liczba jednostek: {count}",
        "unit_name": "Jednostka",
        "units": "Jednostki",
        "unpublish": "Nie opublikowano",
        "unpublished": "Cofnięto publikację",
        "uploadDocument": "Prześlij dokumenty",
        "validation_errors": "Z tą propozycją są problemy. Najpierw je rozwiąż, a potem spróbuj ponownie.",
        "when": "Kiedy",
        "who": "Komu",
        "withAll": "Wszystkim",
        "withClient": "Tylko z {client}",
        "withCustomer": "Klientowi",
        "withCustomerName": "Klientowi: {customer}",
        "withPartners": "Tylko partnerom decyzyjni",
        "yes": "Tak"
      },
      "legend": {
        "approvedAfterDue": "Oferta zatwierdzona po upływie terminu",
        "decisionApproved": "Oferta zatwierdzona",
        "hasDecision": "Nie przesłano jeszcze żadnej oferty",
        "hasProposal": "Przesłano ofertę",
        "isExpired": "Termin upłynął, nie przesłano żadnej propozycji",
        "isExpiredHasProposal": "Termin upłynął, oferta została przesłana",
        "noDecision": "Jednostka wykluczona z tej decyzji ",
        "requested_changes": "Propozycja odrzucona"
      },
      "navigation": {
        "backToDecisions": "Wróć do decyzji"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Nowe decyzje pojawią się już wkrótce!",
            "title": "Przygotuj się do podjęcia decyzji"
          },
          "no_documents": {
            "subtitle": "Tu znajdziesz wszystkie dokumenty związane z tą decyzją",
            "title": "Prześlij dokumenty związane z decyzją: {decision_name}"
          }
        },
        "employees": {
          "conversations": {
            "none": {
              "subtitle": "Od momentu przypisania klienta do tej jednostki zobaczysz tutaj rozmowy",
              "title": "Tutaj znajdziesz wszystkie rozmowy dotyczące tej decyzji"
            }
          },
          "new": {
            "subtitle": "Przypisz decyzję do wielu jednostek naraz",
            "title": "Utwórz swoją pierwszą decyzję"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Kiedy nowa decyzja zostanie opublikowana, otrzymasz powiadomienie e-mail.",
            "title": "Nie masz jeszcze żadnych decyzji"
          }
        }
      },
      "toasts": {
        "bulk_create": "Decyzja została utworzona | Decyzje zostały utworzone",
        "bulk_delete": "Decyzja została usunięta | Decyzje zostały usunięte",
        "bulk_update": "Decyzja została zaktualizowana | Decyzje zostały zaktualizowane",
        "update": "Decyzja została zaktualizowana "
      },
      "validation": {
        "cannotUpdatePrice": "Nie można edytować budżetu, ponieważ raty na podstawie tej decyzji są widoczne dla klienta",
        "installmentsSent": "Niektóre wybrane decyzje mają widoczne dla klienta raty. Ich budżet pozostanie taki sam.",
        "needAttachment": "Prześlij co najmniej jeden nowy dokument lub wybierz jeden z folderu jednostki",
        "needNumber": "Należy podać liczbę (np. 8400,5)",
        "needTitle": "Należy podać tytuł",
        "priceBudgetNotNegative": "Budżet nie może być liczbą ujemną.",
        "selectContactPerson": "Wybierz przynajmniej 1 osobę kontaktową"
      }
    }
  }
}
